// src/pages/Culture.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

// Перенаправляем на страницу "О нас", так как корпоративная культура описана там
export default function Culture() {
  return <Navigate to="/about" replace />;
}